if (!window.JourneyResume) {
  const readState = () => {
    const node = document.querySelector("[data-journey-state]");
    if (!node) return { hasJourney: false };
    try {
      return JSON.parse(node.textContent.trim()) || { hasJourney: false };
    } catch (e) {
      console.error("[journey-resume] failed to parse state", e);
      return { hasJourney: false };
    }
  };

  const state = readState();

  const hasJourney = () => Boolean(state.hasJourney);

  // The dialog is deliberately non-dismissible (no close button, no backdrop click,
  // no Escape), so Tab/Shift+Tab must not be able to walk focus out to the page
  // behind the overlay. The trap itself is shared — assets/focus-trap.js, loaded
  // before this script — so the delivery-date picker can use the same one. If it
  // somehow isn't there, the dialog still works; only the Tab cycling is lost.
  const trapFocus = (modal) => (window.FocusTrap ? window.FocusTrap.trap(modal) : () => {});

  // Resolves ONLY when the customer chooses to start over. The resume action is a plain
  // <a href>, so that path navigates away and this promise is simply never settled --
  // which is correct: the caller must not proceed with destroying the old journey.
  const ask = () =>
    new Promise((resolve) => {
      const modal = document.querySelector("[data-journey-resume]");
      // No dialog rendered means nothing to protect. Never block on a missing element.
      if (!modal) {
        resolve();
        return;
      }
      modal.removeAttribute("hidden");

      const releaseTrap = trapFocus(modal);
      // Primary action first: the safe default is resuming the existing journey,
      // not destroying it, so focus should not default to the destructive option.
      modal.querySelector(".journey-resume__button--primary")?.focus();

      modal.querySelector("[data-jr-start]")?.addEventListener(
        "click",
        async (event) => {
          // Clearing the cart is a round trip, and the button must not look inert while
          // it runs — nor accept a second click that would fire a second clear.
          const btn = event.currentTarget;
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");

          // The other half of starting over. Callers clear the plan's cart ATTRIBUTES
          // (clearedConfigAttributes in section-buying-journey.js), but a plan already
          // built lives in the cart as bundle LINES, and the builder restores from those
          // when the `selections` attribute is gone — so leaving them meant "Start a new
          // plan" handed the customer their old meals straight back.
          //
          // Awaited before resolving: the resume path's caller re-clicks the plan CTA the
          // moment this settles, and that writes cart attributes. Letting the two overlap
          // races two writes onto the same cart.
          try {
            await window.PlanCart?.clearPlanLines();
          } catch (e) {
            // Not fatal — a stale line is recoverable, being stuck at a modal is not.
            console.error("[journey-resume] failed to clear the previous plan", e);
          }

          releaseTrap();
          modal.setAttribute("hidden", "");
          resolve();
        },
        { once: true }
      );
    });

  window.JourneyResume = { hasJourney, ask };
}
